export enum BillStatusTypes {
  Unbilled = 0,
  Billed = 1,
}

export function getBillStatusTypeName(value: BillStatusTypes): string {
  switch (value) {
    case BillStatusTypes.Unbilled: return '未請求';
    case BillStatusTypes.Billed: return '請求済';
  }
}
